import React from 'react';
import PropTypes from 'prop-types';
import {Menu} from 'primereact/menu';
import {AuthenticationService} from 'services/access/AuthenticationService';
import {Redirect} from 'react-router-dom';
import {showDialog} from "../../components/Dialog";
import {FTUComponent} from "../../components/FTUComponent";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import ChangePassword from "./topbarMenu/ChangePassword";

const mapStateToProps = state => ({
    user: state.user.info
});

class AppTopbar extends FTUComponent {

    _isMounted = false;

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
    }

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
        };
    }

    logout = (e) => {
        AuthenticationService.logout();
        if (this._isMounted) {
            this.setState({
                redirect: true
            })
        }
    };

    genChangePassword = () => {
        showDialog(
            <ChangePassword options={{}}/>,
            this.trans("common:app.changePassword"),
            {maxWidth: "40%"}
        );
    };

    renderRedirect = () => {
        if (this.state.redirect) {
            return <Redirect to='/'/>
        }
    };

    render() {
        let items = [{
            label: this.props.user.username + " - " + this.props.user.shopCode,
            items: [
                // {
                //     label: this.trans("common:app.changePassword"),
                //     icon: 'pi pi-fw pi-pencil',
                //     command: this.genChangePassword
                // },
                {
                    label: this.trans("common:app.logout"),
                    icon: 'pi pi-fw pi-power-off',
                    command: this.logout
                }
            ]
        }];
        return (
            <div className="layout-topbar clearfix">
                {this.renderRedirect()}
                <button className="p-link layout-menu-button" onClick={this.props.onToggleMenu}>
                    <span className="pi pi-bars"/>
                </button>
                <div className="p-link layout-topbar-icon topbar-app-title">
                    {this.trans("common:app.title")}
                </div>
                <div className="layout-topbar-icons">
                    <img className="topbar-app-logo" alt="Logo" height="30px" src={this.props.logo}/>
                    {/*<button className="p-link" onClick={this.props.onChangeLgn}>*/}
                    {/*    <span className={"layout-topbar-icon pi lgn-" + this.props.appLgn}*/}
                    {/*          style={{paddingBottom: "22px"}}*/}
                    {/*    />*/}
                    {/*</button>*/}
                    <Menu model={items} popup={true} className={"top-right-menu"} ref={el => this.menu = el} style={{width: "max-content"}}/>
                    <button className="p-link" onClick={(event) => this.menu.toggle(event)}>
                        <span className="layout-topbar-item-text">User</span>
                        <span className="layout-topbar-icon pi pi-user"/>
                    </button>
                </div>
            </div>
        );
    }
}

AppTopbar.defaultProps = {
    onToggleMenu: null,
    onChangeLgn: null,
    appLgn: "vi",
    logo: ""
};

AppTopbar.propTypes = {
    onToggleMenu: PropTypes.func.isRequired
};

export default withTranslation(["changePassword", "common"])(connect(mapStateToProps)(AppTopbar));